import { useState } from "react";
import { useRouter } from "next/router";
import Link from "next/link";

import useUser from "@/components/useUser";
import { Modal } from "./Modal";

const LoginProtectedButton = ({
  className,
  children,
  modalText,
  onClick,
  redirectUrl = null,
}) => {
  const { user } = useUser();
  const [showModal, setShowModal] = useState(false);
  const router = useRouter();

  const next = redirectUrl || encodeURIComponent(router.asPath);

  if (user) {
    return (
      <button className={className} onClick={onClick}>
        {children}
      </button>
    );
  }

  return (
    <>
      <Modal showModal={showModal} closeModal={() => setShowModal(false)}>
        <div>
          <h2 className="subtitle has-text-centered">{modalText}</h2>

          <div className="buttons is-right">
            <Link href={`/signup?next=${next}`} className="button is-warning">
              Sign Up
            </Link>
            <Link href={`/login?next=${next}`} className="button is-light">
              Log In
            </Link>
          </div>
        </div>
      </Modal>

      <button className={className} onClick={() => setShowModal(true)}>
        {children}
      </button>
    </>
  );
};

export default LoginProtectedButton;
